// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #121212;
}

.App {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Full viewport height */
  background-color: #121212; /* Sexy dark background */
  color: #f5f5f5; /* Light text for contrast */
  font-family: 'Arial', sans-serif; /* Clean, modern font */
  font-size: 6rem; /* Make "óh" stand out */
  font-weight: 700; /* Bold text */
  letter-spacing: 0.1rem; /* Slight spacing for elegance */
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,yBAAyB;EACxC,yBAAyB,EAAE,yBAAyB;EACpD,cAAc,EAAE,4BAA4B;EAC5C,gCAAgC,EAAE,uBAAuB;EACzD,eAAe,EAAE,wBAAwB;EACzC,gBAAgB,EAAE,cAAc;EAChC,sBAAsB,EAAE,gCAAgC;AAC1D","sourcesContent":["body {\n  background-color: #121212;\n}\n\n.App {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh; /* Full viewport height */\n  background-color: #121212; /* Sexy dark background */\n  color: #f5f5f5; /* Light text for contrast */\n  font-family: 'Arial', sans-serif; /* Clean, modern font */\n  font-size: 6rem; /* Make \"óh\" stand out */\n  font-weight: 700; /* Bold text */\n  letter-spacing: 0.1rem; /* Slight spacing for elegance */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
